export default __webpack_public_path__ + "static/media/Beard_4_C2.05a166a5.svg";